import { render } from "./AppLangSwitcher.vue?vue&type=template&id=452dd646&scoped=true"
import script from "./AppLangSwitcher.vue?vue&type=script&lang=js"
export * from "./AppLangSwitcher.vue?vue&type=script&lang=js"

import "./AppLangSwitcher.vue?vue&type=style&index=0&id=452dd646&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452dd646"]])

export default __exports__